// extracted by mini-css-extract-plugin
export default {"container":"product-list-staggered-card__container___2ZMnQ"};